import { axiosGet, axiosPost } from './axiosService';

export class AbsherService {
	requestVerification() {
		return axiosPost(null, 'Lenders/absher/request', {
			hide_success_toaster: true,
		});
	}

	getStatus() {
		return axiosGet(null, 'Lenders/absher/status', null, null, {
			hide_toaster: true,
		});
	}
}
